// SEOManager Component - Global SEO Orchestrator
// Created: 2025-12-07
// Purpose: Central component that manages all SEO aspects for the application
// Combines: MetaTags, StructuredData for comprehensive SEO coverage

import React from 'react';
import MetaTags from './MetaTags';
import StructuredData from './StructuredData';
import { SEOPageData } from './types';

interface SEOManagerProps {
  seoData: SEOPageData;
}

const SEOManager: React.FC<SEOManagerProps> = ({ seoData }) => {
  return (
    <>
      <MetaTags seoData={seoData} />
      {seoData.structuredData && seoData.structuredData.length > 0 && (
        <StructuredData data={seoData.structuredData} />
      )}
    </>
  );
};

export default SEOManager;
